import { createApi } from "@reduxjs/toolkit/query/react";

import apiService from "common/shared/services/api.service/api.service";

export const rootApiReducer = createApi({
  reducerPath: "rootApiReducer",
  baseQuery: apiService.axiosBaseQuery({ baseUrl: "" }),
  endpoints: () => ({}),
});
